const apiUrl = process.env.API_URL || "http://localhost:3001/api";

export default apiUrl;
